import { EdgeRouterScope, GenericLabeling, LayoutGraphHider, LayoutGroupingSupport, LayoutStageBase, Maps, StraightLineEdgeRouter } from "yfiles";
export default class HandleEdgesBetweenGroupsStage extends LayoutStageBase {
    constructor(placeLabels, ignoreGrouping, coreLayout) {
        super();
        this.$considerEdgeLabels = placeLabels;
        this.$edgeSelectionKey = new StraightLineEdgeRouter(coreLayout).affectedEdgesDpKey;
        this.$markedEdgeRouter = coreLayout;
        this.$ignoreGrouping = ignoreGrouping;
    }
    get edgeSelectionKey() {
        return this.$edgeSelectionKey;
    }
    set edgeSelectionKey(value) {
        this.$edgeSelectionKey = value;
    }
    get considerEdgeLabels() {
        return this.$considerEdgeLabels;
    }
    set considerEdgeLabels(value) {
        this.$considerEdgeLabels = value;
    }
    applyLayout(graph) {
        if (this.$ignoreGrouping) {
            this.applyLayoutCore(graph);
            return;
        }
        const groupingSupport = new LayoutGroupingSupport(graph);
        if (!LayoutGroupingSupport.isGrouped(graph)) {
            this.applyLayoutCore(graph);
        }
        else {
            const hiddenEdgesMap = Maps.createHashedEdgeMap();
            const edgeHider = new LayoutGraphHider(graph);
            let existHiddenEdges = false;
            for (const edge of graph.edges) {
                if (groupingSupport.isGroupNode(edge.source) || groupingSupport.isGroupNode(edge.target)) {
                    hiddenEdgesMap.set(edge, true);
                    edgeHider.hide(edge);
                    existHiddenEdges = true;
                }
                else {
                    hiddenEdgesMap.set(edge, false);
                }
            }
            this.applyLayoutCore(graph);
            if (existHiddenEdges) {
                edgeHider.unhideAll();
                this.routeMarkedEdges(graph, hiddenEdgesMap);
                if (this.considerEdgeLabels) {
                    const affectedLabelsDpKey = "affectedLabelsDpKey";
                    const nonTreeLabelsMap = Maps.createHashedDataMap();
                    for (const edge of graph.edges) {
                        const ell = graph.getLabelLayout(edge);
                        for (const labelLayout of ell) {
                            nonTreeLabelsMap.set(labelLayout, hiddenEdgesMap.get(edge));
                        }
                    }
                    graph.addDataProvider(affectedLabelsDpKey, nonTreeLabelsMap);
                    const labeling = new GenericLabeling();
                    labeling.placeNodeLabels = false;
                    labeling.placeEdgeLabels = true;
                    labeling.affectedLabelsDpKey = affectedLabelsDpKey;
                    labeling.applyLayout(graph);
                    graph.removeDataProvider(affectedLabelsDpKey);
                }
            }
        }
    }
    routeMarkedEdges(graph, markedEdgesMap) {
        const router = this.$markedEdgeRouter;
        if (router === null) {
            return;
        }
        let backupDP = null;
        if (this.edgeSelectionKey) {
            backupDP = graph.getDataProvider(this.edgeSelectionKey);
            graph.addDataProvider(this.edgeSelectionKey, markedEdgesMap);
        }
        if (router instanceof StraightLineEdgeRouter) {
            router.scope = EdgeRouterScope.ROUTE_AFFECTED_EDGES;
            router.affectedEdgesDpKey = this.edgeSelectionKey;
        }
        router.applyLayout(graph);
        if (this.edgeSelectionKey) {
            graph.removeDataProvider(this.edgeSelectionKey);
            if (backupDP != null) {
                graph.addDataProvider(this.edgeSelectionKey, backupDP);
            }
        }
    }
}
